export const RC_VOLUME_DATA_API_URL='claims-recon-pending-metrics/';
export const RC_VOLUME_DATA_BULK_API_URL='claims-bulk-process-jobs/claims-recon-pending-metrics';
export const RC_AVERAGE_DATA_API_URL='claims-recon-avg-tat-metrics/';
export const RC_AVERAGE_DATA_BULK_API_URL='claims-bulk-process-jobs/claims-recon-avg-tat-metrics';
export const RC_DETAILS_API_URL='claims-recon-details';
export const RC_OUTCOME_VOLUME_DATA_API_URL='claims-recon-outcome-reasons-metrics';
export const RC_OUTCOME_SUBMISSION_DATA_API_URL='claims-recon-provider-reasons-metrics';
export const RECONSIDERATION_DETAILS_DATA_API_URL='claims-recon-details';
